<template>
    <div>
        <el-dialog :close-on-press-escape="true" :title="dataActionBox.boxTitle" :visible.sync="dataActionBox.showStatus" :modal-append-to-body="true" :append-to-body="true" width="500px" center top="2rem">
            <div class="data_action_form">
                <el-card class="box-card" body-style="padding:0;border:none" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <div v-if="scope.index == 0">
                                    <el-form label-width="100px" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row>
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" :key="formOneKey" :prop="formOneValue.entityField"
                                                              :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <df-date class="form_codition" v-if="formOneValue.fieldType == 'date'" :isShowLong="false" v-model="sendDataInfo[formOneValue.entityField]"
                                                             :isdisabled="formOneValue.isChange == 0"></df-date>
                                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search' || formOneValue.searchId" class="item"
                                                                :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input class="form_codition" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                                  @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                                  :disabled="formOneValue.isChange == 0">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                       :disabled="formOneValue.isChange == 0">
                                                            </el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <el-select class="form_codition" clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'"
                                                               :disabled="formOneValue.isChange == 0" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                    <el-input class="form_codition" v-else
                                                              :disabled="formOneValue.isChange == 0"
                                                              v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="initActionBox('sendDataInfo')">取 消</el-button>
                <el-button type="primary" @click="sendDataAction('sendDataInfo')">保 存</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: "openInventoryAction",
    props: ["actionData"],
    components: {
        SearchScheme,
    },
    data() {
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0,
            },
            sendDataInfo: {},
            showTabs: "",
            formDataList: [],
            seId: "",
            seWidth: "",
            seTitle: "",
            DialogVisible: false,
            parentSearchData: {},
            isLoaded: false,
            accountId: "",
            tabForm: [],
            mxForm: [],
            footForm: [],
            sField: "",
            seType: "",
            seIndex: 0,
            isOut: false,
        };
    },
    computed: {},
    watch: {},
    methods: {
        openSearch(sId, index, type, setField) {
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = setField;
            if(type=='worcmCheckerName'){
                this.parentSearchData.opmDelivery = ''
                this.parentSearchData.opmReviewer = 1
                this.parentSearchData.opmAcceptor = ''
                this.parentSearchData.opmSalesperson = ''
                this.parentSearchData.opmBuyer = ''
            }else if(type=='regoName'){
                this.parentSearchData.opmAcceptor = ''
                this.parentSearchData.opmDelivery = 1
                this.parentSearchData.opmReviewer = ''
                this.parentSearchData.opmSalesperson = ''
                this.parentSearchData.opmBuyer = ''
            }else if(type=='pschaName'){
                this.parentSearchData.opmReviewer = ''
                this.parentSearchData.opmAcceptor = 1
                this.parentSearchData.opmDelivery = ''
                this.parentSearchData.opmSalesperson = ''
                this.parentSearchData.opmBuyer = ''
            }else if(type=='opmName'){
                this.parentSearchData.opmSalesperson = 1
                this.parentSearchData.opmDelivery = ''
                this.parentSearchData.opmReviewer = ''
                this.parentSearchData.opmAcceptor = ''
                this.parentSearchData.opmBuyer = ''
            }
            this.DialogVisible = true;
        },
        changeInputModel(val) {
            // console.log(val,'val011111111')
            if (val != "" && val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        paramValue(val) {
                    
            if (this.sField != null && this.sField != '' && this.sField != undefined) {
                let arr = this.sField.split(",");
                // console.log(arr,'arr1111111111111')
                
                arr.forEach((item) => {
                    // console.log(val[item],'111111111111')
                    if (val[item] !== undefined) {
                        this.$set(this.sendDataInfo, item, val[item]);
                    }
                });
            } else if (this.seType) {
                if (val[this.seType] !== undefined) {
                    this.$set(this.sendDataInfo, this.seType, val[this.seType]);
                }
            }
            // console.log(this.sendDataInfo,'this.sendDataInfo11111111')
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        initActionBox(formName) {
            this.sendDataInfo = {};
            this.dataActionBox.showStatus = false;
        },
        async openBox(cate, accountId,isOut) {
            this.initActionBox();
            this.accountId = accountId;
            this.dataActionBox.actionType = cate;
            if(isOut){
                this.isOut = isOut;
            }
            await this.getPageInfo();
            this.dataActionBox.showStatus = true;
        },
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({ ids: [pathId.jurId] });
            if (responseData.status == 200) {
                this.formDataList = responseData.result;
                this.tabForm = [];
                this.mxForm = [];
                this.footForm = [];
                if (this.formDataList.jurFormVoList) {
                    this.formDataList.jurFormVoList.forEach((item, index) => {
                        if (item.isForm == 1) {
                            this.tabForm.push(item);
                        }
                    });
                    this.mxForm = this.formDataList.jurFormVoList.find(item => item.jciType == 3);
                }
                if (this.formDataList.jurFormVoList) {
                    this.footForm = this.formDataList.jurFormVoList.find(item => item.jciType == 4);
                }
                if (this.tabForm.length > 0) {
                    this.showTabs = this.tabForm[0].jciName;
                }
                this.isLoaded = true;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async sendDataAction(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData();
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        async submitData() {
            var sendDataInfo = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.accountId.length > 0) {
                sendDataInfo.accountId = this.accountId;
            }else{
                return this.$message({
                    message: "请选择要处理的数据",
                    type: "warning",
                });
            }
            if (this.isOut != true) {
                var responseData = await this.$http.returnPoolPuOrder(sendDataInfo);
            } else {
                var responseData = await this.$http.returnPoolQcsuOrder(sendDataInfo);
            }
            if (responseData.status == 200) {
                this.initActionBox();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("closeAction");
                this.$parent.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
    },
    created() { },
    mounted() { },
    beforeCreate() { },
    beforeMount() { },
    beforeUpdate() { },
    updated() { },
    beforeDestroy() { },
    destroyed() { },
    activated() { },
};
</script>
<style scoped>
.dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #fff;
    height: 46px;
    padding: 5px 10px;
    margin-top: 20px;
    border-top: 1px solid #eee;
}

.dialog-footer .el-button {
    margin: 0 15px;
    width: 80px;
}

.data_action_form {
    padding: 15px 0;
}

.table_content_box {
    padding: 15px;
    overflow-y: auto;
}

.baseForm .el-form-item {
    margin-bottom: 15px;
}

/* 去掉 box-card 边框和阴影 */
.box-card,
.box-card >>> .el-card,
.box-card >>> .el-card__body {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
}

.box-card >>> .el-card__body {
    padding: 0;
}
</style>